module.exports = __webpack_public_path__ + "static/work-hard-illustration-10cde2e1cd512ba944acd6554e906bbf.png";